import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import PropType from 'prop-types'
import {toDateTime} from '../../shared/functions/toDateTime';
import ShippingDetailList from './dataGrid/ShippingDetailList';
import {groupBy} from 'lodash'
import {useDispatch} from "react-redux";
import {fetchShipping} from "../../redux/slices/shipping";
import {nanoid} from "@reduxjs/toolkit";


const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ShippingDetails({shipping, handleClose}) {
    const classes = useStyles();
    const {Shippings, ContainerCode, CreateAt} = shipping;

    const [list, setList] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [v2ApiHasBeenCalled, setv2ApiHasBeenCalled] = useState(false)
    const dispatch = useDispatch()


    if (!v2ApiHasBeenCalled && Shippings.length === 0) {


        setIsLoading(true)

        dispatch(fetchShipping({
            docId: shipping.id, onResolve: (data) => {
                setIsLoading(false) 
                setList(data)
            }
        }))

        setv2ApiHasBeenCalled(true)

    }

    const convertPriceToDollar =(price) =>{
        if(price > 1000){
            const p = (price / 1125);
            const n = Number(p);
            const r = n.toFixed(2);
            return Number(r);
        }
        return price;
    }


    let ShippingWithId = []
 
    if (list.length > 0) {
        ShippingWithId = list.map((e, idx) => ({...e, Price: convertPriceToDollar(e.Price), id: nanoid()}));
    } else {
        ShippingWithId = Shippings.map((e, idx) => ({...e, Price: convertPriceToDollar(e.Price), id: nanoid()}));
    }

    let groupItem = groupBy(ShippingWithId, "ProductBarcode")

    ShippingWithId = Object.entries(groupItem);
 


    return (
        <div>
            <Dialog fullScreen open onClose={handleClose} TransitionComponent={Transition}>
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                            {ContainerCode} - {toDateTime(CreateAt.seconds).toLocaleString()}
                        </Typography>

                        <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                            <CloseIcon/>
                        </IconButton>
                        <Button autoFocus color="inherit" onClick={handleClose}>
                            retour
                        </Button>
                    </Toolbar>
                </AppBar>
                <ShippingDetailList containerCode={ContainerCode} data={ShippingWithId} shippingId={shipping.id} isLoading={isLoading}/>
            </Dialog>
        </div>
    );
}


ShippingDetails.propTypes = {
    handleClose: PropType.func.isRequired,
    shipping: PropType.object.isRequired,
}
